import classNames from 'classnames';
import React from 'react';
import styles from './SectionTitle.module.scss';

type SectionTitleProps = {
    leftContent?: React.ReactNode;
    rightContent?: React.ReactNode;
    title: React.ReactNode;
    tall?: boolean;
    h1?: boolean;
    h2?: boolean;
    bottomMargin?: boolean;
    topMargin?: boolean;
    warning?: boolean;
};

export function SectionTitle({ title, leftContent, rightContent, tall, h1, h2, bottomMargin, topMargin, warning }: SectionTitleProps) {
    const containerClass = classNames(styles.container, {
        [styles.tall]: tall,
        [styles.heading1]: h1,
        [styles.heading2]: h2,
        [styles.bottomMargin]: bottomMargin,
        [styles.topMargin]: topMargin,
    });

    const sectionTitleClass = classNames(styles.sectionTitle, {
        [styles.warning]: warning,
    });

    return (
        <div className={containerClass}>
            {leftContent}
            <div className={sectionTitleClass}>{title}</div>
            {rightContent}
        </div>
    );
}
